export const getAnoMes = num => {
  if (!num) return "";
  const str = num.toString();
  return `${str.substring(4, 6)}/${str.substring(0, 4)}`;
};
